import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { EASINGS, DURATIONS } from '../../lib/motion';
import { IS_PRERENDER } from '../../lib/prerender';

export default function TextReveal({
  text,
  className = '',
  wordClassName = '',
  delay = 0,
  stagger = 0.08,
  byChar = false,
  blur = 0,
}) {
  const prefersReducedMotion = useReducedMotion();

  if (prefersReducedMotion || IS_PRERENDER) {
    return <span className={className}>{text}</span>;
  }

  const words = text.split(' ');

  return (
    <span className={className} aria-label={text}>
      {words.map((word, i) => {
        const pieces = byChar ? word.split('') : [word];
        return (
          <span key={i} className="inline-block overflow-hidden align-bottom">
            {pieces.map((piece, j) => (
              <motion.span
                key={j}
                className={`inline-block will-change-transform ${wordClassName}`}
                initial={{ y: '110%', opacity: 0, filter: blur ? `blur(${blur}px)` : 'blur(0px)' }}
                animate={{ y: '0%', opacity: 1, filter: 'blur(0px)' }}
                transition={{
                  duration: DURATIONS.component,
                  ease: EASINGS.smooth,
                  delay: delay + (byChar ? (i * word.length + j) * 0.02 : i * stagger),
                }}
              >
                {piece}
              </motion.span>
            ))}
            {i < words.length - 1 ? <span>{'\u00A0'}</span> : null}
          </span>
        );
      })}
    </span>
  );
}